import React, { useMemo, useCallback } from 'react';
import styles from './ServiceTable.module.css'; // 원하는 스타일 적용
import dayjs from 'dayjs';
import { InnocodeButton, InnocodeDatatable, InnocodeInput } from '@intsoft/innocode-core';

export const ADMINROLE = {
  SYS_ADMIN: 'SYS_ADMIN',
  ADMIN_USER: 'ADMIN_USER'
}

const ServiceTable = ({ datas, detailUser, onAddUser, onPageChange, pageNumber, totalCount, listSize, searchValue, setSearchValue, onSearch, isMobileWindow }) => {
  const dateView = (dateView) => { 
    const date = new Date(dateView);
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

  // 행 클릭 핸들러
  const handleRowClick = useCallback((row) => {
    detailUser(row);
  }, [detailUser]);

  // 서비스 관리 버튼 클릭 핸들러
  const handleManageServiceClick = useCallback((e, data) => {
    e.stopPropagation();
    const url = `/service/dashboard?view=service_only&serviceId=${data.serviceId}`;
    window.open(url, '_blank');
  }, []);

  // 페이지 변경 핸들러
  const handlePageChange = useCallback((newPage) => {
    onPageChange(newPage);
  }, [onPageChange]);

  // 컬럼 정의
  const columns = useMemo(() => {
    const baseColumns = [
      {
        id: 'serviceName',
        header: '서비스명',
        accessorKey: 'serviceName',
        enableSorting: true,
        cell: ({ row }) => (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%"
          }}>
            <span>{row.serviceName}</span>
            <InnocodeButton
              size="xs"
              theme="opacity"
              designType="assistive"
              iconOnly={true}
              onClick={(e) => handleManageServiceClick(e, row)}
              icon={
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M9.586 2.586A2 2 0 0 1 11 2h2a2 2 0 0 1 2 2v.089l.473.196.063-.063a2.002 2.002 0 0 1 2.828 0l1.414 1.414a2 2 0 0 1 0 2.827l-.063.064.196.473H20a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-.089l-.196.473.063.063a2.002 2.002 0 0 1 0 2.828l-1.414 1.414a2 2 0 0 1-2.828 0l-.063-.063-.473.196V20a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-.089l-.473-.196-.063.063a2.002 2.002 0 0 1-2.828 0l-1.414-1.414a2 2 0 0 1 0-2.827l.063-.064L4.089 15H4a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h.09l.195-.473-.063-.063a2 2 0 0 1 0-2.828l1.414-1.414a2 2 0 0 1 2.827 0l.064.063L9 4.089V4a2 2 0 0 1 .586-1.414ZM8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" clipRule="evenodd"/>
                </svg>
              }
            />
          </div>
        ),
      },
      {
        id: 'serviceDomain',
        header: '도메인',
        accessorKey: 'serviceDomain',
        enableSorting: true,
        cell: ({ row }) => <span>{row.serviceDomain}</span>,
      },
    ];

    // 모바일이 아닐 때만 등록일 컬럼 추가
    if (!isMobileWindow) {
      baseColumns.push({
        id: 'createdDate',
        header: '등록일',
        accessorKey: 'createdDate',
        enableSorting: true,
        cell: ({ row }) => <span>{dateView(row.createdDateView)}</span>,
      });
    }

    return baseColumns;
  }, [isMobileWindow, handleManageServiceClick]);

  return (
    <div className={styles.tableSection}>
      <InnocodeDatatable
        className={styles.dataTable}
        data={datas}
        columns={columns}
        enableCustomHeader={true}
        customHeader={
          <div className={styles.customHeaderContainer}>
            <div className={styles.customHeaderSearchContainer}>
              <InnocodeInput
                className={styles.customHeaderSearchInput}
                placeholder="서비스명 검색"
                showTrailingContent={true}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onSearch('serviceName', searchValue);
                  }
                }}
                trailingContent={
                  <InnocodeButton
                    enablePadding={false}
                    size="xs"
                    theme="opacity"
                    designType="alternative"
                    iconOnly={true}
                    icon={
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                      </svg>
                    }
                    onClick={() => onSearch('serviceName', searchValue)}
                  />
                }
              />
            </div>
            <div className={styles.customHeaderActionContainer}>
              <InnocodeButton
                designType="primary"
                theme="line"
                size="md"
                onClick={onAddUser}
              >
                서비스 등록
              </InnocodeButton>
            </div>
          </div>
        }
        enableTableHeader={true}
        enableSorting={true}
        enableCheckbox={false}
        enablePagination={true}
        manualPagination={true}
        pageSize={listSize}
        totalCount={totalCount}
        currentPage={pageNumber}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        emptyMessage="서비스가 없습니다."
        rowClassName={styles.tableRow}
      />
    </div>
  );
};

export default ServiceTable;
